import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/refusallist/icon-no-result.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-2dfc8096"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-refusallist" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-refusallist_tit" }, "応募しない求人一覧", -1))
const _hoisted_6 = { class: "p-jobsearch-header" }
const _hoisted_7 = { class: "p-jobsearch-header_inner" }
const _hoisted_8 = { class: "p-jobsearch-control" }
const _hoisted_9 = { class: "p-jobsearch-control_inner" }
const _hoisted_10 = { class: "p-jobsearch-control_count" }
const _hoisted_11 = { class: "p-jobsearch-control_count_highlight" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-list_no-result" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-list_no-result_heading" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "p-jobsearch-list_no-result_img",
        src: _imports_0,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("p", null, "応募を辞退した求人はありません")
    ])
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "p-jobsearch-list" }
const _hoisted_17 = {
  key: 0,
  class: "p-jobsearch-list_more"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "l-wrapper_nav" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "g-pagetop",
  href: "#",
  "aria-label": "ページトップへ戻る"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]

import Loading from '@/components/Loading.vue';
import { onActivated } from 'vue';
import { Job } from '@/types';
import JobListItem from '@/components/JobListItem.vue';
import { ref } from 'vue';
import { TrnShintyokuSelectRequest } from '@/types/request';
import { getRefusalListService, writeLogtrnOperationLogService  } from '@/api/services/shintyokuService';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'RefusalListView',
  setup(__props) {

const jobList = ref<Job[]>([]);
const isLoading = ref(false);
const isAction = ref(true);
const totalCount = ref(0);
const isLoadingMore = ref(false);
const shintyokuSelectParams = ref<TrnShintyokuSelectRequest>({});
const isJobListLoaded = ref(false);

function turnAction(turnValue: boolean){
  isAction.value = turnValue;
}


const hasMore = ref(false);
// src/js/_module/_tooltip.ts
function initializeTooltips() {
  const tooltipOpenButtons = document.querySelectorAll('.js-tooltip-open-button');
  tooltipOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tooltipContainer = button.querySelector('.js-tooltip-container');
      if (tooltipContainer) {
        document.querySelectorAll('.js-tooltip-container.is-active').forEach((openTooltip) => {
          if (openTooltip !== tooltipContainer) {
            openTooltip.classList.remove('is-active');
          }
        });
        tooltipContainer.classList.add('is-active');
      }
    });
  });
  const tooltipCloseTriggers = document.querySelectorAll('.js-tooltip-close-trigger');
  tooltipCloseTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const tooltipContainer = trigger.closest('.js-tooltip-container');
      if (tooltipContainer) {
        tooltipContainer.classList.remove('is-active');
      }
    });
  });
  document.addEventListener('click', (event) => {
    const openTooltips = document.querySelectorAll('.js-tooltip-container.is-active');
    openTooltips.forEach((tooltip) => {
      const openButton = tooltip.parentElement;
      if (openButton && !openButton.contains(event.target) && !tooltip.contains(event.target)) {
        tooltip.classList.remove('is-active');
      }
    });
  });
}

const route = useRoute();
const store = useStore();
onActivated(async () => {
  isLoading.value = true;

  if(route.meta.isBack && isJobListLoaded.value) {
    isLoading.value = false;
    await store.dispatch('favorites/clearFavorite');
    return;
  }

  resetRefs();

  await loadJobList();

  initializeTooltips();
});

async function loadJobList(params?: TrnShintyokuSelectRequest, isFullPageLoading = true){
  isLoading.value = isFullPageLoading;
  try{
    
    const requestParams: TrnShintyokuSelectRequest = {
      ...shintyokuSelectParams.value,
      ...(params || {}),
    };

    const jobSearchState = await getRefusalListService(requestParams);
    const fetchedJobs = jobSearchState.shintyokuList;
    if (fetchedJobs && fetchedJobs.length > 0) {
      if (!isLoadingMore.value) {
        jobList.value = fetchedJobs;
      } else {
        jobList.value = [...jobList.value, ...fetchedJobs];
      }
    }
    totalCount.value = jobSearchState.totalCount;
    shintyokuSelectParams.value.pageCursor = jobSearchState.pageCursor;
    hasMore.value = jobSearchState.hasMore;
    isJobListLoaded.value = true;
  } catch (error) {
    // TODO: Error handle
  }

  if (isFullPageLoading) {
    isLoading.value = false;
    // scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

async function nextPage(){
  if (jobList.value.length < totalCount.value) {
    isLoadingMore.value = true;
    updateShintyokuSelectParams({});
    await loadJobList({}, false);
    isLoadingMore.value = false;
  }
}


const writeLog = async(orderId: number, clientId: number, videoUrl: string) =>
{
  await writeLogtrnOperationLogService({
        orderId: orderId,
        clientId: clientId,        
        operationId: 1,
        videoUrl: videoUrl,
      });
};

function updateShintyokuSelectParams(
  newParams: Partial<TrnShintyokuSelectRequest> = {}, 
  mode: 'replace' | 'merge' = 'merge'
): TrnShintyokuSelectRequest {
  let updatedParams: TrnShintyokuSelectRequest;
  
  if (mode === 'replace') {
    updatedParams = { ...newParams };
  } else {
    updatedParams = { ...shintyokuSelectParams.value };
    Object.entries(newParams).forEach(([key, value]) => {
      const paramKey = key as keyof TrnShintyokuSelectRequest;
      if (typeof value === 'string' || typeof value === 'number' || value === undefined) {
        updatedParams[paramKey] = value as any;
      }
    });
  }

  // Update state
  shintyokuSelectParams.value = updatedParams;

  return updatedParams;
}

const resetRefs = () => {
  shintyokuSelectParams.value = {};
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", null, [
          _createElementVNode("form", null, [
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("p", _hoisted_10, [
                              _createTextVNode("全"),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(totalCount.value), 1),
                              _createTextVNode("件")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (jobList.value.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                      : _createCommentVNode("", true),
                    (jobList.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobList.value, (job, idx) => {
                              return (_openBlock(), _createBlock(JobListItem, {
                                key: job.orderId,
                                job: jobList.value[idx],
                                isBulkSelectionEnabled: false,
                                "screen-name": "reApply",
                                "is-not-show-heart": true,
                                "onWriteLog:pickUp": () => writeLog(Number(job.orderId), Number(job.clientId), job.pickupLink || ''),
                                onTurnAction: turnAction
                              }, null, 8, ["job", "onWriteLog:pickUp"]))
                            }), 128)),
                            (hasMore.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    disabled: isLoadingMore.value,
                                    class: "p-jobsearch-btn __blue __more",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (nextPage()))
                                  }, [
                                    _createTextVNode(" 検索結果をもっと見る"),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["p-jobsearch-btn_ico", {'loading-spinner': isLoadingMore.value}])
                                    }, null, 2)
                                  ], 8, _hoisted_18)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, _hoisted_21, 512), [
        [_vShow, !isLoading.value]
      ])
    ]),
    _createVNode(Loading, {
      "is-loading": isLoading.value || !isAction.value
    }, null, 8, ["is-loading"])
  ], 64))
}
}

})